function SimpleSlideshow(sel) {
    this.total_slideshow_slides = 0
    this.slideshow_sel = sel;
    this.slideshow_slick_sel = sel + ' .slides';
    this.slideshow_arrow_left = sel + ' .arrow.left';
    this.slideshow_arrow_right = sel + ' .arrow.right';
    this.self = this
}

SimpleSlideshow.prototype.init = function() {
    this.slickslideshowInit()
    $(window).on("resize", this.resize.bind(this.self))
    this.self.resize()
}

//////////////////////////////////////////////////////////////////////////////////////////
SimpleSlideshow.prototype.slickslideshowInit = function () {
    let t = this
    //check to see how many slides there are
    this.total_slideshow_slides = $(this.slideshow_slick_sel + " .slide").length
    if (this.total_slideshow_slides===1) {
        $(this.slideshow_arrow_left).hide()
        $(this.slideshow_arrow_right).hide()

        $(this.slideshow_slick_sel).addClass('one-slide')
        $(this.slideshow_sel + ' .photo-zone-label').addClass('one-slide')
        $(this.slideshow_sel).addClass('no-arrows')
    }

    //large
    let slidesPerPanel = 1
    let displaySlides = slidesPerPanel;
    if (this.total_slideshow_slides < slidesPerPanel) {
        displaySlides = this.total_slideshow_slides
    }

    //listeners
    $(this.slideshow_slick_sel).on('init reInit', this.slickslideshowSlideInit);
    $(this.slideshow_slick_sel).on('beforeChange', this.slickslideshowBeforeChange);
    $(this.slideshow_slick_sel).on('afterChange', this.slickslideshowAfterChange);
    $(this.slideshow_slick_sel).on('click', '.slick-slide', function (e) {
        e.stopPropagation();
        let index = $(this).data("slick-index");
        if ($(t.slideshow_slick_sel).slick('slickCurrentSlide') !== index) {
            $(t.slideshow_slick_sel).slick('slickGoTo', index);
        }
    });

    $(this.slideshow_arrow_left).click(function () {
        $(t.slideshow_slick_sel).slick('slickPrev');
        t.killAutoplayslideshow();
    });
    $(this.slideshow_arrow_right).click(function () {
        $(t.slideshow_slick_sel).slick('slickNext');
        t.killAutoplayslideshow();
    });


    //start it
    $(t.slideshow_slick_sel).slick({
        infinite: true,
        centerMode: false,
        //centerPadding: '360px',
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        rows:0,
        //vertical: true,
        responsive: [
            {

            },
        ]
    });
}

SimpleSlideshow.prototype.slickslideshowSlideInit = function (e) {
    $(window).trigger('resize')
}

SimpleSlideshow.prototype.slickslideshowBeforeChange = function (event, slick, currentSlide, nextSlide) {

}
SimpleSlideshow.prototype.slickslideshowAfterChange = function (event, slick, currentSlide) {

}
SimpleSlideshow.prototype.killAutoplayslideshow = function () {
    $(this.slideshow_slick_sel).slick('slickPause');
},

//////////////////////////////////////////////////////////////////////////////////////////
SimpleSlideshow.prototype.resize = function (evt) {
    
}

export default SimpleSlideshow